import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import money from 'v-money'

// This library must be imported first than router
import '@/libs/ls-slim'
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";

import router from './router'
import store from './store'
import App from './App.vue'
import Multiselect from 'vue-multiselect'
Vue.component("multiselect", Multiselect);

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
//import '@/libs/socket-io-client'
import '@/libs/portal-vue'
import '@/libs/quill'
import '@/libs/toastification'
import i18n from '@/libs/i18n'
import '@/libs/price_filters'
import '@/libs/moment_filters'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

//const msalInstance = new PublicClientApplication(msalConfig);
// Account selection logic is app dependent. Adjust as needed for different use cases.

// V-Money
Vue.use(money, { precision: 2 })

const asd = {
msalConfig: {
    auth: {
        clientId: '779d37a9-dda4-43d6-82a8-eacd9933e6e9',
        authority:
            'https://login.microsoftonline.com/c2513a7d-4153-46c7-8dbf-5c6d673d2f74',
        redirectUri: 'https://location-manager.backoffice.americar.com/redirect',
        //redirectUri: 'http://localhost:8080/redirect',
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        clientCapabilities: ['CP1'], // this lets the resource owner know that this client is capable of handling claims challenge.
    },
    cache: {
        cacheLocation: 'localStorage',
    },
}
}
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
Vue.prototype.$msalInstance = new PublicClientApplication(asd.msalConfig)

Vue.config.productionTip = false
new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app')
